<template>
  <div class="mini-seat-layout">
    <div class="seat-grid">
      <div
          v-for="(row, rowIndex) in seatGrid"
          :key="rowIndex"
          class="seat-row"
      >
        <div
            v-for="(seat, seatIndex) in row"
            :key="seatIndex"
            class="seat"
            :class="{
            'seat-available': !seat.isReserved && seat.isActive,
            'seat-reserved': seat.isReserved && seat.isActive,
            'seat-disabled': !seat.isActive
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import type { SeatLayoutInfo } from '@/types'

interface Props {
  layout: SeatLayoutInfo
  reservedSeatNumbers?: number[]
}

const props = withDefaults(defineProps<Props>(), {
  reservedSeatNumbers: () => []
})

interface SeatInfo {
  isReserved: boolean
  isActive: boolean
}

const seatGrid = ref<SeatInfo[][]>([])

const generateGrid = (rows: number, seatsPerRow: number, seatStatus: number[][] | null) => {
  const grid: SeatInfo[][] = []

  let seatNumber = 1
  for (let row = 0; row < rows; row++) {
    const rowSeats: SeatInfo[] = []
    for (let col = 0; col < seatsPerRow; col++) {
      const isReserved = props.reservedSeatNumbers.includes(seatNumber)
      const isActive = seatStatus ? seatStatus[row][col] === 1 : true

      rowSeats.push({
        isReserved,
        isActive
      })

      if (isActive) seatNumber++
    }
    grid.push(rowSeats)
  }

  return grid
}

const parseSeatLayout = () => {
  if (!props.layout) return
  const rows = props.layout.rows || 5
  const seatsPerRow = props.layout.seatsPerRow || 8
  const seatStatus = props.layout.seatStatus
  seatGrid.value = generateGrid(rows, seatsPerRow, seatStatus)
}

onMounted(() => parseSeatLayout())
watch(() => props.layout, () => parseSeatLayout())
watch(() => props.reservedSeatNumbers, () => parseSeatLayout())
</script>

<style scoped>
.mini-seat-layout {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seat-grid {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.seat-row {
  display: flex;
  gap: 1px;
}

.seat {
  width: 6px;
  height: 6px;
  border-radius: 1px;
}

.seat-available {
  background-color: #22c55e; /* 초록 */
}

.seat-reserved {
  background-color: #ef4444; /* 빨강 */
}

.seat-disabled {
  background-color: #d1d5db; /* 회색 */
}
</style>
